import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

import PDFIcon from "assets/icons/pdf.svg?react";
import XLSIcon from "assets/icons/xls.svg?react";
import OtherIcon from "assets/icons/other.svg?react";
import PngIcon from "assets/icons/png.svg?react";
import JpgIcon from "assets/icons/jpg.svg?react";
import DocIcon from "assets/icons/doc.svg?react";
import TXTIcon from "assets/icons/txt.svg?react";
import PptIcon from "assets/icons/ppt.svg?react";
import RarIcon from "assets/icons/rar.svg?react";
import ZipIcon from "assets/icons/zip.svg?react";
import PsdIcon from "assets/icons/psd.svg?react";
import SvgIcon from "assets/icons/svg.svg?react";
import GifIcon from "assets/icons/gif.svg?react";
import MovIcon from "assets/icons/mov.svg?react";

import PDFIcon2 from "assets/icons/files/pdf.svg?react";
import XLSIcon2 from "assets/icons/files/xls.svg?react";
import OtherIcon2 from "assets/icons/files/other.svg?react";
import PngIcon2 from "assets/icons/files/png.svg?react";
import JpgIcon2 from "assets/icons/files/jpg.svg?react";
import DocIcon2 from "assets/icons/files/doc.svg?react";
import TXTIcon2 from "assets/icons/files/txt.svg?react";
import PptIcon2 from "assets/icons/files/ppt.svg?react";
import RarIcon2 from "assets/icons/files/rar.svg?react";
import ZipIcon2 from "assets/icons/files/zip.svg?react";
import PsdIcon2 from "assets/icons/files/psd.svg?react";
import SvgIcon2 from "assets/icons/files/svg.svg?react";
import MovIcon2 from "assets/icons/files/mov.svg?react";

const AttachmentIconComponent: FC<Props> = ({ file, className, newIcons }) => {
  const name = file.split(".");
  const extenstion = name[name.length - 1]?.toLocaleLowerCase();

  switch (extenstion) {
    case "jpg":
      return newIcons ? (
        <JpgIcon2 className={`${styles.icon} ${className}`} />
      ) : (
        <JpgIcon className={`${styles.icon} ${className}`} />
      );
    case "gif":
      return newIcons ? (
        <GifIcon className={`${styles.icon} ${className}`} />
      ) : (
        <GifIcon className={`${styles.icon} ${className}`} />
      );
    case "xlsx":
    case "xls":
      return newIcons ? (
        <XLSIcon2 className={`${styles.icon} ${className}`} />
      ) : (
        <XLSIcon className={`${styles.icon} ${className}`} />
      );
    case "pdf":
      return newIcons ? (
        <PDFIcon2 className={`${styles.icon} ${className}`} />
      ) : (
        <PDFIcon className={`${styles.icon} ${className}`} />
      );
    case "png":
      return newIcons ? (
        <PngIcon2 className={`${styles.icon} ${className}`} />
      ) : (
        <PngIcon className={`${styles.icon} ${className}`} />
      );
    case "doc":
    case "docx":
      return newIcons ? (
        <DocIcon2 className={`${styles.icon} ${className}`} />
      ) : (
        <DocIcon className={`${styles.icon} ${className}`} />
      );
    case "ppt":
    case "pptx":
      return newIcons ? (
        <PptIcon2 className={`${styles.icon} ${className}`} />
      ) : (
        <PptIcon className={`${styles.icon} ${className}`} />
      );
    case "txt":
      return newIcons ? (
        <TXTIcon2 className={`${styles.icon} ${className}`} />
      ) : (
        <TXTIcon className={`${styles.icon} ${className}`} />
      );
    case "zip":
    case "7z":
      return newIcons ? (
        <ZipIcon2 className={`${styles.icon} ${className}`} />
      ) : (
        <ZipIcon className={`${styles.icon} ${className}`} />
      );
    case "rar":
      return newIcons ? (
        <RarIcon2 className={`${styles.icon} ${className}`} />
      ) : (
        <RarIcon className={`${styles.icon} ${className}`} />
      );
    case "mov":
      return newIcons ? (
        <MovIcon2 className={`${styles.icon} ${className}`} />
      ) : (
        <MovIcon className={`${styles.icon} ${className}`} />
      );
    case "psd":
      return newIcons ? (
        <PsdIcon2 className={`${styles.icon} ${className}`} />
      ) : (
        <PsdIcon className={`${styles.icon} ${className}`} />
      );
    case "svg":
      return newIcons ? (
        <SvgIcon2 className={`${styles.icon} ${className}`} />
      ) : (
        <SvgIcon className={`${styles.icon} ${className}`} />
      );
    default:
      return newIcons ? (
        <OtherIcon2 className={`${styles.icon} ${className}`} />
      ) : (
        <OtherIcon className={`${styles.icon} ${className}`} />
      );
  }
};

export default AttachmentIconComponent;
